export default __webpack_public_path__ + "static/media/equip-about.3b07da73.webp";